<template>
  <div>
    <b-modal v-if="windowWidth <= 576" id="modal-inbox" class="modal-inbox" scrollable :no-close-on-backdrop=true :title="label" :no-close-on-esc=true v-model="show" 
      :dialog-class="'b-dialog-large'"
      :ok-title="okTitle"
      ok-variant="success" 
      :cancel-title="cancelTitle" 
      @ok="saveAction"
      @hidden="onHidden">
      <template #modal-header>
        <div class="w-100">
          <b-row>
            <b-col class="d-flex pl-0">
              <span class="mr-1">
                  <b-button size="sm" class="ml-1 btn-back" @click="$bvModal.hide('modal-inbox')"><b-icon-arrow-left /></b-button>
              </span>
              <h5 class="modal-title"><app-long-text :maxLength="15" :text="label" /></h5>
            </b-col>
          </b-row>
        </div>
      </template>
      <template #modal-footer>
        <PortalTarget class="float-right d-flex mt-04 mr-3" name="app-inbox-button" />
      </template>
      <slot/>
    </b-modal>
    <div v-else>
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PopupWrap',
  data() {
    return {
      //show: false,
      editor: [],
      isExpanded: false,
      windowWidth: 0,
    }
  },
  filters: {
   short_hand (name) {
    let words = name.split(" ")
    let short_hand = words[0][0] + (words[words.length-1] != undefined && words[words.length-1] != null && words[words.length-1] != '' ? words[words.length-1][0] : "")
    return short_hand;
   }
  },
  props: {
    isShow: {
      default: false,
      type: Boolean,
    },
    isLarge: {
      default: true
    },
    centered: {
      default: true,
      type: Boolean,
    },
    focusElement: {
      default: null,
      type: Object,
    },
    label: {
      required: true,
      type: String,
    },
    entityName: {
      type: String,
    },
    documentId: {
      type: String,
    },
    okTitle: {
      default: 'Simpan',
      type: String,
    },
    cancelTitle: {
      default: 'Batal',
      type: String,
    },
    isBusy: {
      default: false,
      type: Boolean,
    }
  },
  computed: {
    show : {
      get(){
        this.onResize();
        return this.isShow;
      },
      set(newName){
        return newName
      } 
      
    }
  },
  mounted() {
    const close = (e) => {
      const ESC = 27;
      if (e.keyCode !== ESC) return;
      this.$emit('close');
    };
    this.$nextTick(() => {
        window.addEventListener('resize', this.onResize);
    });
    this.activate();
    this.$on('hook:destroyed', () => {
      this.deactivate();
    });
  },
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    activate() {
      this.previousActiveElement = document.activeElement;
      this.inert();
    },
    saveAction(modalEvent) {
      this.$emit("saveMethod", modalEvent);
    },
    onHidden() {
      this.$emit('resetModal');
      this.$emit('hideMethod');
      this.$emit('close');
    },
    async deactivate() {
      await this.inert(false);
    },
    async inert(status = true) {
      await this.$nextTick();
      [...this.$root.$el.children].forEach((child) => {
        if (child === this.$el || child.contains(this.$el)) return;
        child.inert = status;
      });
    },
    getVariant(index) {
      let variant = ['warning', 'danger', 'info', 'primary', 'success'];
      if (index > (variant.length - 1)) {
        index = index % variant.length;
      }
      return variant[index];
    },
    async checkEditor() {
      if (this.documentId != null && this.documentId != undefined && this.documentId != 'null' && this.documentId != '') {
        this.$http.get(process.env.VUE_APP_API_URL + this.entityName + '/currenteditor/' + this.documentId)
        .then(response => {
          if (response != null) {
            this.editor = [];
              if (response.data.length > 0) {
                response.data.forEach(item => {
                  if (this.editor.indexOf(item) < 0) {
                    this.editor.push(item);
                  }
                });
              }
          }
        }).catch(error => {});
      }
    },
  },
  watch : {
    documentId(newValue, oldValue) {
      if (newValue != oldValue)
          this.checkEditor();
    },
    isShow(newValue) {
      console.log('isShow', newValue);
      //this.show = newValue;
    }
  }
};
</script>

<style>
.modal-dialog {
    max-width: 1008px !important;
    height: 100vh;
    display: flex;
}
.modal-body {
  background: #EEF0F8 !important;
}

.b-dialog-small {
  max-width: 50% !important;
}

.b-dialog-large {
  max-width: 99% !important;
  max-height: 100% !important;
}

@media (max-width:768px) {
  .modal-dialog {
    max-width: 100% !important;
  } 

  .b-table-top-row {
    background: #f3f6f9 !important;
  }
}
@media (max-width: 576px) {
  .modal-dialog {
    max-width: 100% !important;
  }

  .b-table-top-row {
    background: #f3f6f9 !important;
  }
}
</style>